//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchUpdateState } from "@/api/PMS/customerService/lostAndFound/lostManagement";
import waves from "@/directive/waves"; // 水波纹指令

export default {
  directives: {
    waves: waves
  },
  data: function data() {
    return {
      rules: {},
      childData: {}
    };
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.$refs.dataForm.resetFields();
      }
    }
  },
  props: ["keyValue", "showDialog"],
  created: function created() {},
  methods: {
    handCancle: function handCancle() {
      this.$emit("handCancle", false);
    },
    handCreate: function handCreate() {
      var _this = this;

      this.$refs["dataForm"].validate(function (valid) {
        if (valid) {
          _this.childData.id = _this.keyValue;
          _this.childData.foundStatus = 1;
          _this.childData.publishStatus = 2;
          fetchUpdateState(_this.childData).then(function (res) {
            if (res.data.code === 200) {
              _this.$emit("handCancle", true);

              _this.$message({
                message: "确认找到成功",
                type: "success"
              });
            }
          });
        } else {
          _this.Alert({
            alertType: "valid"
          });
        }
      });
    }
  }
};